import React from 'react'
import StudentSidebar from '../../StudentSidebar/StudentSidebar'
import { Link } from 'react-router-dom'

const StudentTutorList = () => {
    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Bookings
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="browse-tutor">
                                    <div
                                        className="card input-card-form filter-card btn"
                                        data-bs-toggle="modal"
                                        data-bs-target="#filterModal"
                                    >
                                        <div className="card-body p-1">
                                            <div className="row justify-content-center">
                                                <div className="col-lg-10 col-md-10 col-10 text-start">
                                                    <span>
                                                        <i className="fa-solid fa-filter" />
                                                    </span>
                                                    <span className="filter-text ms-2">Filter</span>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-2 d-flex justify-content-end align-items-center">
                                                    <i className="fa-solid fa-chevron-down" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-6 col-md-6 mt-3">
                                            <div className="card input-card-form">
                                                <div className="card-body">
                                                    <div className="row justify-content-center">
                                                        <div
                                                            className="col-lg-4 col-md-4 col-sm-4 mb-3"
                                                            style={{ width: "fit-content" }}
                                                        >
                                                            <img
                                                                src="/assets/img/user/user5.jpg"
                                                                className="img-fluid rounded-circle"
                                                                style={{ height: "7.6rem", width: "auto" }}
                                                            />
                                                        </div>
                                                        <div
                                                            className="col-lg-8 col-md-8"
                                                            style={{ width: "fit-content" }}
                                                        >
                                                            <h5 className="mb-0">Annu Yadav</h5>
                                                            <p className="mb-0">Biology</p>
                                                            <p className="mb-0">2 Year experience</p>
                                                            <div className="rating">
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star" />
                                                                </span>
                                                                <span>
                                                                    4.0 <span className="text-primary">(4.0 Ratings)</span>
                                                                </span>
                                                            </div>
                                                            <button
                                                                className="btn btn-primary py-1 w-100 mt-1"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#tutordetailsModal"
                                                            >
                                                                View Profile
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 mt-3">
                                            <div className="card input-card-form">
                                                <div className="card-body">
                                                    <div className="row justify-content-center">
                                                        <div
                                                            className="col-lg-4 mb-3 col-md-4 col-sm-4"
                                                            style={{ width: "fit-content" }}
                                                        >
                                                            <img
                                                                src="/assets/img/user/user5.jpg"
                                                                className="img-fluid rounded-circle"
                                                                style={{ height: "7.6rem", width: "auto" }}
                                                            />
                                                        </div>
                                                        <div
                                                            className="col-lg-8 col-md-8"
                                                            style={{ width: "fit-content" }}
                                                        >
                                                            <h5 className="mb-0">Annu Yadav</h5>
                                                            <p className="mb-0">Biology</p>
                                                            <p className="mb-0">2 Year experience</p>
                                                            <div className="rating">
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star" />
                                                                </span>
                                                                <span>
                                                                    4.0 <span className="text-primary">(4.0 Ratings)</span>
                                                                </span>
                                                            </div>
                                                            <button
                                                                className="btn btn-primary py-1 w-100 mt-1"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#tutordetailsModal"
                                                            >
                                                                View Profile
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 mt-3">
                                            <div className="card input-card-form">
                                                <div className="card-body">
                                                    <div className="row justify-content-center">
                                                        <div
                                                            className="col-lg-4 mb-3 col-md-4 col-sm-4"
                                                            style={{ width: "fit-content" }}
                                                        >
                                                            <img
                                                                src="/assets/img/user/user5.jpg"
                                                                className="img-fluid rounded-circle"
                                                                style={{ height: "7.6rem", width: "auto" }}
                                                            />
                                                        </div>
                                                        <div
                                                            className="col-lg-8 col-md-8"
                                                            style={{ width: "fit-content" }}
                                                        >
                                                            <h5 className="mb-0">Annu Yadav</h5>
                                                            <p className="mb-0">Biology</p>
                                                            <p className="mb-0">2 Year experience</p>
                                                            <div className="rating">
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star" />
                                                                </span>
                                                                <span>
                                                                    4.0 <span className="text-primary">(4.0 Ratings)</span>
                                                                </span>
                                                            </div>
                                                            <button
                                                                className="btn btn-primary py-1 w-100 mt-1"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#tutordetailsModal"
                                                            >
                                                                View Profile
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 mt-3">
                                            <div className="card input-card-form">
                                                <div className="card-body">
                                                    <div className="row justify-content-center">
                                                        <div
                                                            className="col-lg-4 mb-3 col-md-4 col-sm-4"
                                                            style={{ width: "fit-content" }}
                                                        >
                                                            <img
                                                                src="/assets/img/user/user5.jpg"
                                                                className="img-fluid rounded-circle"
                                                                style={{ height: "7.6rem", width: "auto" }}
                                                            />
                                                        </div>
                                                        <div
                                                            className="col-lg-8 col-md-8"
                                                            style={{ width: "fit-content" }}
                                                        >
                                                            <h5 className="mb-0">Annu Yadav</h5>
                                                            <p className="mb-0">Biology</p>
                                                            <p className="mb-0">2 Year experience</p>
                                                            <div className="rating">
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star text-warning" />
                                                                </span>
                                                                <span>
                                                                    <i className="fa-solid fa-star" />
                                                                </span>
                                                                <span>
                                                                    4.0 <span className="text-primary">(4.0 Ratings)</span>
                                                                </span>
                                                            </div>
                                                            <button
                                                                className="btn btn-primary py-1 w-100 mt-1"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#tutordetailsModal"
                                                            >
                                                                View Profile
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Filter Modal */}
                <div
                    className="modal fade"
                    id="filterModal"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    <i className="fa-solid fa-filter" />
                                    <span className="ms-2">Filter</span>
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <h6 className="my-2">Select Tutoring</h6>
                                    </div>
                                    <div className="col-lg-6">
                                        <input type="radio" name="tutoring" defaultValue="option1" />
                                        <span>One to One Tutoring</span>
                                    </div>
                                    <div className="col-lg-6">
                                        <input type="radio" name="tutoring" defaultValue="option2" />
                                        <span>Group Tutoring</span>
                                    </div>
                                    <div className="col-lg-12">
                                        <h6 className="mb-2 mt-4">Select Rating</h6>
                                    </div>
                                    <div className="col-lg-6">
                                        <input type="radio" name="rating" defaultValue="option1" />
                                        <span>High to Low</span>
                                    </div>
                                    <div className="col-lg-6">
                                        <input type="radio" name="rating" defaultValue="option2" />
                                        <span>Low to High</span>
                                    </div>
                                    <div className="col-lg-12">
                                        <h6 className="mb-2 mt-4">Select Experience</h6>
                                    </div>
                                    <div className="col-lg-4">
                                        <input type="radio" name="exp" defaultValue="option1" />
                                        <span>0-1 Year</span>
                                    </div>
                                    <div className="col-lg-4">
                                        <input type="radio" name="exp" defaultValue="option2" />
                                        <span>1-2 Year</span>
                                    </div>
                                    <div className="col-lg-4">
                                        <input type="radio" name="exp" defaultValue="option3" />
                                        <span>1-2 Year</span>
                                    </div>
                                </div>
                                <div></div>
                            </div>
                            <div className="modal-footer">
                                {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                                <Link to="/student/tutor-list">
                                    <button type="button" className="btn btn-primary px-3 py-1" data-bs-dismiss="modal">
                                        Apply
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Tutor Details Modal */}
                <div
                    className="modal fade tutor-details-modal"
                    id="tutordetailsModal"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Tutor Details
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                <div className="row mb-2">
                                    <div className="col-lg-4">
                                        <img
                                            src="/assets/img/user/user5.jpg"
                                            className="img-fluid"
                                            style={{ height: "7.6rem", width: "auto" }}
                                        />
                                    </div>
                                    <div className="col-lg-8 col-md-8" style={{ width: "fit-content" }}>
                                        <h5 className="mb-0">Annu Yadav</h5>
                                        <p className="mb-0">Experience: 2 Years</p>
                                        <p className="mb-0">Ratings</p>
                                        <div className="rating">
                                            <span>
                                                <i className="fa-solid fa-star text-warning" />
                                            </span>
                                            <span>
                                                <i className="fa-solid fa-star text-warning" />
                                            </span>
                                            <span>
                                                <i className="fa-solid fa-star text-warning" />
                                            </span>
                                            <span>
                                                <i className="fa-solid fa-star text-warning" />
                                            </span>
                                            <span>
                                                <i className="fa-solid fa-star" />
                                            </span>
                                            <span>
                                                4.0 <span className="text-primary">(4.0 Ratings)</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-lg-12 mb-2">
                                        <p className="mb-0">Subject</p>
                                        <h6>
                                            Eco, Other, Hindi, Social Media, Biology, Mathematics, English
                                        </h6>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <p className="mb-0">Tutoring</p>
                                    </div>
                                    <div className="col-lg-10">
                                        <h6>One to One</h6>
                                    </div>
                                    <div className="col-lg-2">
                                        <p>$25</p>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <p className="mb-0">Group Tutoring</p>
                                    </div>
                                    <div className="col-lg-10">
                                        <h6>Group Class</h6>
                                    </div>
                                    <div className="col-lg-2">
                                        <p>$20</p>
                                    </div>
                                </div>
                                <div></div>
                            </div>
                            <div className="modal-footer d-flex flex-lg-nowrap flex-md-nowrap">
                                {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                                <Link to="/student/request-for-one-to-one">
                                    <button type="button" className="btn btn-outline-primary" data-bs-dismiss="modal">
                                        Request for One to One Tutoring
                                    </button>
                                </Link>
                                <Link to="/student/view-group-courses">
                                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal">
                                        View Group Courses
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        </div>
    )
}

export default StudentTutorList